import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const { isAdminAuthenticated, loginAdmin } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (isAdminAuthenticated) {
    return <Navigate to="/admin" replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await loginAdmin(email, password);
      toast.success("Admin login successful");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(err?.message || "Unable to login");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="pt-24 px-6 md:px-12 pb-20 min-h-screen flex items-center justify-center" data-testid="admin-login-page">
      <div className="w-full max-w-md border border-black/10 bg-white">
        <div className="bg-[#0A0A0A] text-white p-8 pb-10">
          <div className="label-eyebrow text-[#C9A961] mb-3">Restricted Area</div>
          <h1 className="font-display text-3xl md:text-4xl tracking-tighter leading-[0.95]">
            Admin<br />
            <span className="italic font-light text-[#C9A961]">login only.</span>
          </h1>
          <p className="mt-5 text-sm text-white/60">
            Enter the configured admin email and password.
          </p>
        </div>

        <form onSubmit={onSubmit} className="p-8 space-y-5">
          <label className="block">
            <span className="label-eyebrow block mb-2">Email</span>
            <input
              type="email"
              required
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-black/30 px-4 py-3 focus:border-black focus:outline-none"
              data-testid="admin-email"
            />
          </label>

          <label className="block">
            <span className="label-eyebrow block mb-2">Password</span>
            <input
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-black/30 px-4 py-3 focus:border-black focus:outline-none"
              data-testid="admin-password"
            />
          </label>

          <button
            type="submit"
            disabled={submitting}
            className="w-full bg-black text-white h-12 text-sm tracking-wide hover:bg-[#C9A961] transition-colors disabled:opacity-60"
            data-testid="admin-login-btn"
          >
            {submitting ? "Signing in..." : "Sign in to Admin"}
          </button>
        </form>
      </div>
    </div>
  );
}
